import { render, staticRenderFns } from "./Holidays.vue?vue&type=template&id=591f2700"
import script from "./Holidays.vue?vue&type=script&lang=js"
export * from "./Holidays.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports